export const EXCUSE_REQUEST_TYPES_LOAD = 'EXCUSE_REQUEST_TYPES_LOAD'
export const EXCUSE_REQUEST_TYPES_LOAD_FULFILLED = 'EXCUSE_REQUEST_TYPES_LOAD_FULFILLED'
export const EXCUSE_REQUEST_TYPES_LOAD_REJECTED = 'EXCUSE_REQUEST_TYPES_LOAD_REJECTED'
